import React, { FC } from 'react';

import { AssetIcon } from '../AssetIcon';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/shared/ui';

type AssetWithIconProps = {
    assetName: string;
    assetSymbol?: string;
    className?: string;
    textClassName?: string;
    withTooltip?: boolean;
};

export const AssetWithIcon: FC<AssetWithIconProps> = ({
    assetName,
    assetSymbol,
    className,
    withTooltip = false,
    textClassName,
}) => {
    return (
        <div
            data-testid={`asset${assetSymbol ? `-${assetSymbol}` : ''}${assetName ? `-${assetName}` : ''}`}
            className={`flex items-center ${className || ''}`}
        >
            <AssetIcon assetName={assetSymbol || assetName} className='h-8 w-8 mr-2' />
            {withTooltip ? (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <div className='text-[14px] font-semibold font-[Inter] cursor-pointer'>
                                {assetName}
                            </div>
                        </TooltipTrigger>
                        <TooltipContent
                            side='bottom'
                            sideOffset={52}
                            className='w-auto max-w-max whitespace-nowrap p-4 text-sm bg-background-alwaysDark text-content-inversePrimary rounded'
                        >
                            {assetName}
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            ) : (
                <div className={`text-[14px] font-semibold font-[Inter] ${textClassName}`}>
                    {assetName}
                </div>
            )}
        </div>
    );
};
